import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=810d7480&scoped=true&"
import script from "./TeamView.vue?vue&type=script&lang=ts&"
export * from "./TeamView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810d7480",
  null
  
)

export default component.exports